interface IBase64File {
  filename: string;
  mime_type: string;
  filestream: string;
  encoding?: string;
}

export const decodeBase64File = (data: unknown): { file: Blob; filename: string } => {
  const response = data as IBase64File | null;
  if (
    !response ||
    typeof response.filename !== 'string' ||
    !response.filename ||
    typeof response.mime_type !== 'string' ||
    !response.mime_type ||
    typeof response.filestream !== 'string' ||
    !response.filestream.trim() ||
    (response.encoding !== undefined && response.encoding !== 'base64')
  ) {
    throw new Error('Invalid file response');
  }

  const binary = atob(response.filestream.replace(/\s/g, ''));
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
  if (!bytes.length) throw new Error('Empty file response');

  return {
    file: new Blob([bytes], { type: response.mime_type }),
    filename: response.filename,
  };
};
